<template>
<div>
  <div class="title-bar title-h3">{{selectTitle}}</div>
  <hr class="mr-b20">
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h4">차단 포트 목록</div>
      <div class="setting-addel mr-l15">
        <el-button size="mini" @click="addControlPort"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="!selected" @click="deleteDetectDirectory"><i class="fas fa-minus"></i></el-button>
      </div>
    </div>
    <div>
      <el-button :disabled="!modified" size="small" type="primary" @click="editPortAccessList">저장</el-button>
      <el-button :disabled="!modified" size="small" @click="loadData">취소</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper class="mr-b20" :data="dataList" :columns="portAccessColumns" :column-default="columnDefault" @selection-change="portChangeSelection" :pagination="true" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
    <template slot-scope="scope" slot="startTimeSlot">
        <w-time-picker-by-min :timeData="scope.row.startTime" :rowData="scope" @change="changePicker"></w-time-picker-by-min>
      </template>
    <template slot-scope="scope" slot="endTimeSlot">
        <w-time-picker-by-min :timeData="scope.row.endTime" :pickerOptions="endPickerOptions" :rowData="scope" @change="changePicker"></w-time-picker-by-min>
      </template>
  </el-table-wrapper>
  <w-port-control-popup ref="portControlPopup" @reload-data="loadData" :selectPhysicalNode="selectPhysicalNode" :editRow="editRow" :popup-type="controlPopupType"></w-port-control-popup>
</div>
</template>

<script>
import moment from 'moment';
import { forEach, isNil, clone, cloneDeep, differenceWith, isEqual } from 'lodash';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WPortControlPopup from '@/views/settings/server/SecuritySettings/PortAccessControlView/popup/PortControlPopup';
import WTimePickerByMin from '@/views/settings/server/SecuritySettings/component/TimePickerByMin';

export default {
  name: 'WPortAccessListView',
  components: {
    WPortControlPopup,
    WTimePickerByMin,
  },
  props: {
    selectPhysicalNode: Object,
  },
  data() {
    return {
      columnDefault,
      controlPopupType: null,
      endPickerOptions: null,
      selectTitle: '',
      modified: false,
      dataList: null,
      compareList: null,
      showSearchTool: false,
      serverId: null,
      editRow: {},
      selectedPortList: [],
      portAccessColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'portNumber',
          label: '포트번호',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'label',
          label: 'TCP 포트명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'startTime',
          label: '차단 시작 시각',
          scopedSlot: 'startTimeSlot',
        },
        {
          prop: 'endTime',
          label: '차단 종료 시각',
          scopedSlot: 'endTimeSlot',
        },
      ],
    };
  },
  computed: {
    selected() {
      return this.selectedPortList.length > 0;
    },
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode) && this.selectPhysicalNode.type === 'obj') {
          this.serverId = this.selectPhysicalNode.serverId;
          this.selectTitle = `[${this.selectPhysicalNode.label}] 포트 접근 차단`;
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      ServerSettingAPI.getPortControlList({
        serverId: this.serverId,
      }).then((response) => {
        if (response.data.success) {
          this.dataList = response.data.data;
          this.compareList = cloneDeep(response.data.data);
          this.modified = false;
        }
      });
    },
    /**
     * [addControlPort 포트 접근 차단 항목을 추가한다.]
     * @author yelim
     */
    addControlPort() {
      // 팝업 open시 default 값을 설정한다.
      const startDatetime = moment();
      this.controlPopupType = 'ADD';
      startDatetime
        .year(1970)
        .month(0)
        .date(1);
      startDatetime
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0);
      const endDatetime = moment();
      endDatetime
        .year(1970)
        .month(0)
        .date(1);
      endDatetime
        .hours(23)
        .minutes(0)
        .seconds(0)
        .milliseconds(0);
      this.editRow = {
        startTime: startDatetime.toDate().getTime(),
        endTime: endDatetime.toDate().getTime(),
      };
      this.$refs.portControlPopup.open();
    },
    /**
     * [deleteDetectDirectory 포트 접근 차단 항목을 삭제한다.]
     * @author yelim
     */
    deleteDetectDirectory() {
      const convertParam = clone(this.selectedPortList);
      const saveParamList = [];
      forEach(convertParam, (item) => {
        saveParamList.push({
          serverId: item.serverId,
          portNumber: item.portNumber,
        });
      });
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        const target = '차단 포트';
        ServerSettingAPI.deletePortControl(saveParamList)
          .then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    portChangeSelection(selectVal) {
      this.selectedPortList = cloneDeep(selectVal);
    },
    /**
     * [changePicker TimePickerByMin 컴포넌트의 시간 변경시 수행 로직]
     * @author yelim
     * @param  {[type]} value     [description]
     * @param  {[type]} scopeData [description]
     * @return {[type]}           [description]
     */
    changePicker(value, scopeData, cmp) {
      const row = scopeData.row;
      const prop = scopeData.column.property;

      const timeValue = this.convertTimeStringToDate(value);
      if (this.validateTime(row, prop, timeValue)) {
        row[prop] = timeValue;
      } else {
        // 유효한 값이 아닐 경우 비교한 시각 값과 동일한 값을 설정한다.
        const validValue = prop === 'startTime' ? row.endTime : row.startTime;
        cmp.setValue(validValue);
      }
      this.modified = differenceWith(this.dataList, this.compareList, isEqual).length > 0;
    },
    /**
     * 시각 문자열을 Date로 치환한다.
     * @author Ju
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    convertTimeStringToDate(value) {
      const splitData = value.split(':');
      const datetime = moment();
      datetime
        .year(1970)
        .month(0)
        .date(1);
      datetime
        .hours(splitData[0])
        .minutes(splitData[1])
        .seconds(0)
        .milliseconds(0); // 0시0분0초 설정
      return datetime.toDate().getTime();
    },
    /**
     * [editPortAccessList 포트 접근 차단 항목을 수정한다.]
     * @author yelim
     */
    editPortAccessList() {
      // 수정항목이 존재하는 리스트를 추려낸다.
      const saveParamList = differenceWith(this.dataList, this.compareList, isEqual);
      const target = '포트 차단 시각';
      const action = msgUtil.action.SAVE;
      ServerSettingAPI.updatePortControl(saveParamList)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    /**
     * 설정한 시각에 대한 유효성 검사를 한다. (시작시각/종료시각 비교)
     * @author Ju
     * @param  {[type]} row   [description]
     * @param  {[type]} prop  [description]
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    validateTime(row, prop, value) {
      if (prop === 'startTime') {
        return value <= row.endTime;
      }
      return value >= row.startTime;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/SecuritySettings/PortAccessControlView/component/PortAccessListView.vue